@switch (type) {
  @case ('action') {
    <div class="bg-grey-20 generic-icon">
      <img [src]="image" tImgFallback />
    </div>
  }
  @case ('payment') {
    <div class="bg-green-30 generic-icon text-green-90">
      <t-icon key="paid" size="medium" color="inherit"></t-icon>
    </div>
  }
  @case ('message') {
    <div class="bg-yellow-30 generic-icon text-amber-70">
      <t-icon key="mail" size="medium" color="inherit"></t-icon>
    </div>
  }
  @case ('pa') {
    <div class="bg-green-30 generic-icon text-green-90">
      <t-icon key="bookmark-added" size="medium" color="inherit"></t-icon>
    </div>
  }
}
